import { graphql } from '@generated/gql';

export const FetchOrganizationThemeTokens = graphql(`
  query fetchOrganizationThemeTokens($organizationId: String!) {
    fetchOrganization(organizationId: $organizationId) {
      organization {
        id
        themeTokens
        useParentThemeTokens
      }
    }
  }
`);

export const UpdateOrganizationThemeTokens = graphql(`
  mutation updateOrganizationThemeTokens($input: UpdateOrganizationInput!) {
    updateOrganization(input: $input) {
      organization {
        id
      }
    }
  }
`);
